import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import { registerPlugins } from './plugins'
import { DateTime } from 'luxon'

const app = createApp(App)

registerPlugins(app)

Date.prototype.addDays = function(days: number | string) {
    const dayCount = typeof days === 'number' ? days : parseInt(days, 10);

    if (isNaN(dayCount)) {
      throw new Error("Invalid number of days: " + days);
    }

    const initialDate = new Date(this);
    const updatedDate = DateTime.fromJSDate(initialDate).plus({ days: dayCount });
    const localizedDateString = updatedDate.toLocaleString(DateTime.DATE_SHORT);

    return localizedDateString;
};

Date.prototype.addMonths = function(months: number | string) {
    const monthCount = typeof months === 'number' ? months : parseInt(months, 10);

    if (isNaN(monthCount)) {
      throw new Error("Invalid number of months: " + months);
    }

    const initialDate = new Date(this);
    const updatedDate = DateTime.fromJSDate(initialDate).plus({ months: monthCount });
    const localizedDateString = updatedDate.toLocaleString(DateTime.DATE_SHORT);

    return localizedDateString;
};

Date.prototype.addYears = function(years: number | string) {
    const yearCount = typeof years === 'number' ? years : parseInt(years, 10);

    if (isNaN(yearCount)) {
      throw new Error("Invalid number of years: " + years);
    }

    const initialDate = new Date(this);
    const updatedDate = DateTime.fromJSDate(initialDate).plus({ years: yearCount });
    const localizedDateString = updatedDate.toLocaleString(DateTime.DATE_SHORT);

    return localizedDateString;
};

Date.prototype.toString = function() {
    var intlSettings = Intl.DateTimeFormat().resolvedOptions()
    return this.toLocaleString(intlSettings.locale, {timeZone: intlSettings.timeZone})
} 

Date.prototype.getAge = function() {
    var today = new Date();
    var age = today.getFullYear() - this.getFullYear();
    var m = today.getMonth() - this.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < this.getDate())) {
        age--;
    }
    return age;
};

Date.prototype.equals = function(comparison: Date) {
    return this.getTime() == comparison.getTime()
};

app.mount('#app')
